import React, { useState } from "react";
import {
  TextField,
  Button,
  Grid2 as Grid,
  LinearProgress,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { Query, Settings } from "../../../shared/types";
import { OptionalTextField } from "../components";

export interface QueryInputProps {
  query: Query;
  busy: boolean;
  settings: Settings;
  handleSearch: () => void;
  handleQueryChange: (value: Query) => void;
}

export const QueryInput = ({
  settings,
  query,
  busy,
  handleSearch,
  handleQueryChange,
}: QueryInputProps): React.JSX.Element | null => {
  const [locationAvailable, setLocationAvailable] = useState<boolean>(
    navigator.geolocation != null && navigator.geolocation != undefined
  );

  if (settings.allowSearch) {
    return (
      <Grid
        size={{ xs: 12 }}
        container
        spacing={2}
        style={{ marginBottom: "6px" }}
      >
        <Grid size={{ xs: 12, sm: 10 }}>
          <TextField
            value={query.text}
            fullWidth={true}
            label="Keyword, Location, Charity Name, or EIN"
            InputProps={{
              className: "tb_search_input",
            }}
            InputLabelProps={{ className: "tb_search_label" }}
            onChange={(
              event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            ) => {
              handleQueryChange({ ...query, text: event.target.value });
            }}
            onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
              if (event.code == "Enter") {
                handleSearch();
              }
            }}
          />
        </Grid>
        {/* <Grid item xs={12} sm={4}>
          <FormControl fullWidth>
            <InputLabel id="charity-search-category-label">
              Charity Category
            </InputLabel>
            <Select
              value={query.category}
              fullWidth={true}
              labelId="charity-search-category-label"
              id="charity-search-category"
              label="Charity Category"
              onChange={(event: SelectChangeEvent) => {
                handleQueryChange({
                  ...query,
                  category: event.target.value,
                });
              }}
            >
              <MenuItem value="A">Arts, Culture and Humanities</MenuItem>
              <MenuItem value="B">
                Educational Institutions and Related Activities
              </MenuItem>
              <MenuItem value="C">
                Environmental Quality, Protection and Beautification
              </MenuItem>
              <MenuItem value="D">Animal-Related</MenuItem>
              <MenuItem value="E">Health - General and Rehabilitative</MenuItem>
              <MenuItem value="F">Mental Health, Crisis Intervention</MenuItem>
              <MenuItem value="G">
                Diseases, Disorders, Medical Disciplines
              </MenuItem>
              <MenuItem value="H">Medical Research</MenuItem>
              <MenuItem value="I">Crime, Legal-Related</MenuItem>
              <MenuItem value="J">Employment, Job-Related</MenuItem>
              <MenuItem value="K">Food, Agriculture and Nutrition</MenuItem>
              <MenuItem value="L">Housing, Shelter</MenuItem>
              <MenuItem value="M">
                Public Safety, Disaster Preparedness and Relief
              </MenuItem>
              <MenuItem value="N">
                Recreation, Sports, Leisure, Athletics
              </MenuItem>
              <MenuItem value="O">Youth Development</MenuItem>
              <MenuItem value="P">
                Human Services - Multipurpose and Other
              </MenuItem>
              <MenuItem value="Q">
                International, Foreign Affairs and National Security
              </MenuItem>
              <MenuItem value="R">
                Civil Rights, Social Action, Advocacy
              </MenuItem>
              <MenuItem value="S">
                Community Improvement, Capacity Building
              </MenuItem>
              <MenuItem value="T">
                Philanthropy, Voluntarism and Grantmaking Foundations
              </MenuItem>
              <MenuItem value="U">
                Science and Technology Research Institutes, Services
              </MenuItem>
              <MenuItem value="V">
                Social Science Research Institutes, Services
              </MenuItem>
              <MenuItem value="W">
                Public, Society Benefit - Multipurpose and Other
              </MenuItem>
              <MenuItem value="X">
                Religion-Related, Spiritual Development
              </MenuItem>
              <MenuItem value="Y">
                Mutual/Membership Benefit Organizations, Other
              </MenuItem>
              <MenuItem value="Z">Unknown</MenuItem>
            </Select>
          </FormControl>
        </Grid> */}
        <Grid size={{ xs: 12, sm: 2 }}>
          <Button
            fullWidth={true}
            onClick={(event) => {
              if (query.text || query.category) {
                handleSearch();
              }
            }}
            variant="outlined"
            className="tb_action_button"
            style={{ height: "56px" }}
          >
            Search
          </Button>
        </Grid>
        {!locationAvailable && (
          <Grid size={{ xs: 12 }}>
            <Typography variant="body1">
              Click{" "}
              <Button
                onClick={() => {
                  navigator.geolocation.getCurrentPosition(
                    (location) => {
                      handleQueryChange({
                        ...query,
                        range: 0,
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude,
                      });
                    },
                    () => {
                      handleQueryChange({
                        ...query,
                        range: 0,
                        latitude: 0,
                        longitude: 0,
                      });
                    }
                  );
                }}
              >
                here
              </Button>{" "}
              to rank charities nearby higher.
            </Typography>
          </Grid>
        )}
        <Grid size={{ xs: 12 }}>
          {busy && <LinearProgress style={{ marginBottom: "16px" }} />}
        </Grid>
      </Grid>
    );
  } else {
    return null;
  }
};
